import { SETTINGS_ANALYSIS_THRESHOLDS } from '../settings-paths';
import { SettingsGroupCard, SettingsHubPage, SettingsNavItem } from '../settings-shared';

export function SettingsAnalysisHubPage() {
  return (
    <SettingsHubPage title="Настройки анализа">
      <SettingsGroupCard title="Параметры">
        <SettingsNavItem
          title="Пороги и доступ"
          subTitle="Параметры и allowlist"
          to={SETTINGS_ANALYSIS_THRESHOLDS}
        />
        <SettingsNavItem
          title="Анализ товара"
          subTitle="Один SKU, период FBO"
          to="/settings/product-analysis"
          isLast
        />
      </SettingsGroupCard>
    </SettingsHubPage>
  );
}
